import styled from '@emotion/styled';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import React from 'react'
import Chip from '@mui/material/Chip';
import Reviews from './Reviews';
import ExternalReviews from './ExternalReviews';
import mainContext from '../../../contexts/mainContext';
import { getHouseKeeperProfileController } from '../../../Controllers/userManagment/houseKeeper';
import { updateUserStatus } from '../../../Controllers/userManagment/common';

import AvailabilityCalender from '../../Common/AvailabilityCalender';
import CloseIcon from '@mui/icons-material/Close';
import { __constants, __snackBarSeverity, __snackBarText } from '../../../constants';
import { CleaningEqpImg, CleaningProductImg } from '../../../assets/images/images';
import moment from "moment"
import IdVerification from '../../Common/IdVerification'



const HouseKepper = ({ open, setOpen, userId }) => {
    const { setCanvasTitle, setSnackBar, setPageload } = React.useContext(mainContext)

    /* Maintain state */
    const [state, setState] = React.useState({
        userInfo: {},
        availableFor: [],
        interestedFor: [],
        experience: [],
        languages: [],
        pic: null,
        rawImage: null
    })

    const [currentMonth, setCurrentMonth] = React.useState(moment().format("YYYY-MM"))
    
    const getHouseKeeperProfile = async (month = moment().format("YYYY-MM")) => {
        const res = await getHouseKeeperProfileController(userId, month);

        // return
        if (res.status === 200) {
            setState({
                ...state,
                ...res.data,
                rawImage: __constants.images + res.data.userInfo.profilePicture
            })
        } else {
            return callSnackBar(res.message, "error")
        }
        setPageload(false)
    }

    /* Call snackbar */
    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    const handleMonthChange = (newMonth) => {
        setCurrentMonth(newMonth)
        getHouseKeeperProfile(newMonth)
      }

    React.useEffect(() => {
        if (open) {
            getHouseKeeperProfile();
        }
        setCanvasTitle("House keeper profile");
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Container>
                <Header>
                    <h4>{state?.userInfo?.firstName} {state?.userInfo?.lastName} profile</h4>
                    <CloseIcon className='pointer' onClick={() => { setOpen(false) }} />
                </Header>
                <Body className='scroll-bar-hidden'>
                    <ProfilePic>
                       <div className="img-container">
                        <img
                            onError={(e) => { setState({ ...state, rawImage: `${__constants.images}default_upscaled.png` }) }}
                            src={state.rawImage}
                        />
                         </div>
                    </ProfilePic>

                    <UserDeatils>
                        <UserAbout>
                            <strong className="title">
                                Onboarding Progress
                            </strong>
                            <div style={{ marginTop: '0.5rem', fontSize: '90%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isEmailVerify ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isEmailVerify ? 1 : 0.6 }}>Email Verified</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isMobileNoVerify ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isMobileNoVerify ? 1 : 0.6 }}>Mobile Verified</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isProfileCompleted ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isProfileCompleted ? 1 : 0.6 }}>Basic Profile Created</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isJobProfileCompleted ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isJobProfileCompleted ? 1 : 0.6 }}>Job Profile Completed</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.stripeAccountOnBoard?.completedOn || state?.userInfo?.paypalAccountOnBoard?.completedOn ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.stripeAccountOnBoard?.completedOn || state?.userInfo?.paypalAccountOnBoard?.completedOn ? 1 : 0.6 }}>Payment Method Setup</span>
                                </div>
                                <IdVerification
                                    userId={userId}
                                    verification={state?.userInfo?.stripeIdentityVerification}
                                    badgeEnabled={state?.userInfo?.isIdVerifiedBadge}
                                />
                            </div>
                        </UserAbout>
                        <Divider className='divider-gap' />
                        <UserAbout>
                            <strong className="title">
                                About
                            </strong>
                            <p>{state?.userInfo?.aboutMe}</p>
                        </UserAbout>
                        <Divider className='divider-gap' />
                        <Expericence>
                            <strong className="title">
                                Experience
                            </strong>
                            <div>
                             {state?.userInfo?.experience?.length > 0 &&
                             state.userInfo.experience[0].from &&
                             state.userInfo.experience[0].to && (
                                <Chip className="mui-hk-clip" label={`${state?.userInfo?.experience?.length > 0 && state?.userInfo?.experience[0].from} - ${state?.userInfo?.experience?.length > 0 && state?.userInfo?.experience[0].to} years`} size="small" color="primary" />
                            )}
                             <ul>
                                    {
                                        state?.availableFor.map((e) => {
                                            return (
                                                <li key={e._id} className={`${!e.isMarked && "inactive"}`}>
                                                    <Icon>
                                                        <img src={__constants.images + e.image} />
                                                    </Icon>
                                                    {e.name}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div>
                             {state?.userInfo?.referrenceDocument?.length > 0 && (
                                <Chip className="mui-hk-clip" label="References" size="small" />
                              )}
                                <ul>
                                    {state?.userInfo?.referrenceDocument && state?.userInfo?.referrenceDocument[0]?.length > 0 && state?.userInfo?.referrenceDocument[0].map((item) => <li><a className='pointer' href={__constants.images + item.name} target="_blank">View reference</a></li>)}
                                    <li> {state?.userInfo?.referrenceDocument && state?.userInfo?.referrenceDocument[0]?.length === 0 && "Not available"}</li>
                                </ul>
                            </div>
                        </Expericence>
                        <Divider className='divider-gap' />
                        <Services>
                            <strong className="title">
                                Services
                            </strong>
                            {state?.interestedFor?.length > 0 && (
                            <div>
                                <Chip className="mui-hk-clip" label="Does" size="small" />
                                <ul>
                                    {
                                        state.interestedFor.map((e) => {
                                            return (
                                                <li key={e._id} className={`${!e.isMarked && "inactive"}`}>
                                                    <Icon>
                                                        <img src={__constants.images + e.image} />
                                                    </Icon>
                                                    {e.name}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            )}
                          {(state?.userInfo?.cleaningEquipment?.length > 0 ||
                            state?.userInfo?.haveCleaningProduct?.length > 0) && (
                            <div>
                                <Chip className="mui-hk-clip" label="Has" size="small" color="primary" />
                                <ul>
                                    {
                                        state?.userInfo?.cleaningEquipment?.length > 0 &&
                                        <li className={`${state?.userInfo?.cleaningEquipment[0] && "inactive"}`}>
                                            <Icon>
                                                <img src={CleaningEqpImg} />
                                            </Icon>
                                            Cleaning equipment
                                        </li>

                                    }
                                    {
                                        state?.userInfo?.haveCleaningProduct?.length > 0 &&
                                        <li className={`${state?.userInfo?.haveCleaningProduct[0] && "inactive"}`}>
                                            <Icon>
                                                <img src={CleaningProductImg} />
                                            </Icon>
                                            Cleaning products
                                        </li>
                                    }

                                </ul>
                            </div>
                          )}
                        </Services>
                        <Divider className='divider-gap' />
                        <Languages>
                            <strong className="title">
                                Speaks
                            </strong>
                            <div>
                                {
                                    state?.userInfo?.languages?.length > 0 && state?.userInfo?.languages[0].map((e, index) => {
                                        return (
                                            <Chip className="mui-hk-clip"
                                                key={index}
                                                label={e}
                                                size="small"
                                                color="primary"
                                            />
                                        )
                                    })
                                }
                            </div>
                        </Languages>
                        <Divider className='divider-gap' />
                        <Availability>
                            <strong className="title">
                                Availability
                            </strong>

                            <AvailabilityCalender profile='HouseKeeper' availabilityTime={state?.userInfo?.availabilityTime?.length > 0 ? state?.userInfo?.availabilityTime[0] : null} onMonthChange={handleMonthChange} />
                        </Availability>
                        <Divider className='divider-gap' />

                        <Reviews reviewDetails={state?.userInfo?.reviewDetails} review={state?.userInfo?.review} userId={userId} />
                        <Divider className='divider-gap' />
                        <ExternalReviews userId={userId} />
                    </UserDeatils>
                </Body>
            </Container>
        </>
    )
}

const Container = styled("div")`
    height: 100%;
    width: 30vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
    .divider-gap{
        margin: 0.5rem 0;
    }
    .button{
      border-radius: 10px;
      width: 100%;
      text-transform: unset;
      display: flex;
      font-family: 'semi-bold'
    }
    .image_handler{
        height: 200px;
        width: 100%;
        object-fit: cover;
    }
    .inactive{
        opacity:0.5
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

const ProfilePic = styled("div")`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    
    .img-container {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid #e2a988;
    }
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

const Name = styled("div")`
    font-weight: 600;
    color: #fff;
`;

const Ratings = styled("div")`
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
    font-size: 80%;
    color: #fff;
`;

const Icon = styled("div")`
display:inline-block;
margin-right:10px;
img{
    max-width:20px;
}
`

const UserDeatils = styled("div")`
    width: 95%;
    margin: auto;
`;

const UserAbout = styled("div")`
    margin-top: 0.5rem;
    p{
        margin-top: 0.3rem;
        font-size: 80%;
        font-family: "regular";
    }
`;

const Expericence = styled("div")`
    &>div{
        margin-top: 0.5rem;
        font-size: 90%;
        display: flex;
        justify-content:space-between;
        ul{
            width:65%;
        }
        li{
            margin:6px 0;
            display:flex;
            align-items:center;
        }
        column-gap: 1rem;
    }
`;

const Services = styled("div")`
    &>div{
        margin-top: 0.5rem;
        font-size: 90%;
        display: flex;
        justify-content:space-between;
        ul{
            width:65%;
        }
        li{
            margin:6px 0;
            display:flex;
            align-items:center;
        }
    }
`;

const Languages = styled("div")`
    div{
        margin-top: 0.3rem;
        display: flex;
        flex-wrap: wrap;
        column-gap: 0.5rem;
    }
`;

const Availability = styled("div")`
`;

const Footer = styled("div")`
    margin: auto;
    margin-top: 5%;
    padding-bottom: 5%;
    width: 95%;
    display: flex;
    justify-content: center;
    column-gap: 1rem;
`;

export default HouseKepper